import {
  AuthInfo,
  CustomerAcocuntList,
  EditBeneficiaryParam,
  ORISReportSearch,
  RefreshKftcAgreementDate,
  SubmitORISReport,
  ThreeDigitCodeEmail,
} from "./../../../model/shared/user/user";
import { PasswordChange } from "./../../../view-model/common/passwordchange";
import { LoginResult } from "./../../../response/loginresult";
import { Admin } from "./../../../model/admin/admin";
import { ADMServiceChargeByTypeResult } from "./../../../response/admin/admservicechargeresult";
import {
  FIUReportListItem,
  FIUReportDetail,
} from "../../../model/admin/fiureport/fiureportlistitem";
import { FIUReportSearch } from "../../../model/admin/fiureport/fiureportsearch";
import { FxRate } from "../../../model/admin/fxrate";
import { ServiceCharge } from "../../../model/admin/servicecharge";
import { FxRateHistorySearch } from "../../../model/shared/admin/fxratehistory";
import {
  User,
  Agent,
  Customer,
  Account,
  ValidAccount,
  AgentType,
} from "../../../model/shared/user/user";
import { ADMFxRateHistoryResult } from "../../../response/admin/admfxratehistoryresult";
import {
  ADMFxRateResult,
  ADMFxRateHistoryListResult,
} from "../../../response/admin/admfxrateresult";
import { ADMHomeResult } from "../../../response/admin/admhomeresult";
import { ADMSanctionWatchResult } from "../../../response/admin/admsanctionwatchresult";
import { ADMPartnerDetailResult } from "../../../response/admin/admpartnerdetailresult";
import { ADMPartnersResult } from "../../../response/admin/admpartnersresult";
import { ADMReportPartnerDetailResult } from "../../../response/admin/admreportpartnerdetailresult";
import { ADMReportPartnerResult } from "../../../response/admin/admreportpartnerresult";
import { ADMServiceChargeDetailResult } from "../../../response/admin/admservicechargedetailresult";
import { ADMServiceChargeResult } from "../../../response/admin/admservicechargeresult";
import { ADMTimeResult } from "../../../response/admin/admtimeresult";
import { BaseResponse } from "../../../response/internal/baseresponse";
import { Api } from "../../config/api";
import { AgentService } from "../agent.service";
import { RequestService } from "../request.service";
import { SessionService } from "../session.service";
import { UserService } from "../user.service";
import { Injectable } from "@angular/core";
import { RequestOptions } from "@angular/http";
import { Subject, Observable } from "rxjs/Rx";
import { UserSearch } from "../../../model/shared/user/usersearch";
import {
  UserListResult,
  CustomerListResult,
  ReceiverListResult,
} from "../../../response/userlistresult";
import { UserRegisterResult } from "../../../response/userregistresult";
import {
  UserModifyResult,
  UserValidateMobile,
  UserVerifyMobile,
  UserValidateMobileResult,
  CustomerUpdateValidResult,
} from "../../../response/usermodifyresult";
import { AccountValidation } from "../../../model/shared/user/validation";
import { UserDetailResult } from "../../../response/userdetailresult";
import {
  TransactionSearch,
  TransactionSubInfSearch,
} from "../../../model/shared/transaction/transactionsearch";
import { TransactionApproveResult } from "../../../response/transactionapproveresult";
import { TransactionPendingResult } from "../../../response/transactionpendingresult";
import { TransactionCancelResult } from "../../../response/transactioncancelresult";
import {
  RefundClaimModel,
  RefundResult,
  TransactionDetailResult,
} from "../../../response/transactiondetailresult";
import { InbTransactionDetailResult } from "../../../response/transactiondetailresult";
import { TransactionListResult } from "../../../response/transactionlistresult";
import { InbTransactionListResult } from "../../../response/transactionlistresult";
import {
  TransactionSubInfListResult,
  TransactionSubInfResult,
} from "../../../response/transactionlistresult";

import { TransactionRateResult } from "../../../response/transactionrateresult";
import { TransactionSaveResult } from "../../../response/transactionsaveresult";
import { TransactionCancel } from "../../../view-model/agent/transactioncancel";
import { TransactionApprove } from "../../../view-model/agent/transactionapprove";
import { TransactionPending } from "../../../view-model/agent/transactionpending";
import { PayoutCountryListResult } from "../../../response/internal/list/payoutcountrylist";
import {
  PayoutBranchListResult,
  PayoutBankListResult,
  AgentListResult,
  PayoutBranch,
  AgentDetailResult,
} from "../../../response/internal/list/agentlistresult";
import { Payment } from "../../../model/shared/transaction/payment";
import {
  Transaction,
  TransactionDetail,
  InbTransactionDetail,
  ReqCheckRemittance,
  SubInfTransaction,
} from "../../../model/shared/transaction/transaction";
import {
  BranchDetailResult,
  BranchListResult,
} from "../../../response/branchdetailresult";
import { UserRemittanceResult } from "../../../response/userremittanceresult";
import {
  DepositHistoryResult,
  DepositHistoryListSearch,
  DepositHistory,
  BankDepositHistoryResult,
} from "../../../response/deposithistoryresult";
import {
  DepositHistoryByCheckedList,
  MailSubscribe,
} from "../../../model/shared/mail/mailRequest";
import { UserTransactionList } from "../../../model/shared/transaction/transaction";
import { UserTransactionListResult } from "../../../response/usertransactionlistresult";
import { TransactionReadytoPay } from "app/view-model/agent/transacitonreadytopay";
import { TransactionReadytoPayResult } from "app/response/transactionreadytopayresult";
import { TransactionCheckAMLResult } from "app/response/transactioncheckamlresult";
import { TransactionCheckRemittanceResult } from "app/response/transactioncheckremittanceresult";
import { TransactionCheckOFACResult } from "app/response/transactioncheckofacresult";
import { TransactionCheckOtherSenderResult } from "app/response/transactioncheckothersender";
import { Notice } from "../../../model/shared/notice/notice";
import { NoticeSearch } from "../../../model/shared/notice/noticesearch";
import { NoticeListResult } from "../../../response/noticelistresult";
import { NoticeDetailResult } from "../../../response/noticedetailresult";
import { NoticeModifyResult } from "../../../response/noticemodifyresult";
import { Push } from "../../../model/shared/notice/push";
import { PushSearch } from "../../../model/shared/notice/pushsearch";
import { PushListResult } from "../../../response/pushlistresult";
import { PushDetailResult } from "../../../response/pushdetailresult";
import { PushModifyResult } from "../../../response/pushmodifyresult";
import { Version } from "../../../model/shared/mobile/version";
import { VersionSearch } from "../../../model/shared/mobile/versionsearch";
import { VersionListResult } from "../../../response/versionlistresult";
import { VersionDetailResult } from "../../../response/versiondetailresult";
import { VersionModifyResult } from "../../../response/versionmodifyresult";
import { RefundModel } from "app/model/admin/refundcause";
import { ExpiredSearch } from "../../../view-model/admin/expiredmanage";
import { EmailData } from "app/model/shared/maildata";
import { ReqDeleteAccount } from "app/model/shared/accountdelete";
import { UpdateMailingInfo } from "app/admin/mailing/mailing.component";
import { PartnerGroupResult } from "app/response/partnergroupresult";
import { PassNoResult } from "app/response/passnoresult";
import { AlienRegCardResult } from "app/response/alienregcardresult";
import { CustomerStatisticsResponse } from "app/model/shared/statistics";

@Injectable()
export class AdminService {
  _options: RequestOptions;
  _isLogin: Boolean = this.sessionService.getAdminLogin();
  _loginSubscription: Subject<boolean>;
  _adminInfo: User;

  _selectedFIUItem: FIUReportListItem;

  constructor(
    userService: UserService,
    public sessionService: SessionService,
    public requestService: RequestService
  ) {
    this._loginSubscription = this.sessionService.admLoginStatus;
    this._options = new RequestOptions();
    this._options.headers = userService._options.headers;
  }
  time(): Observable<ADMTimeResult> {
    return this.requestService.get(
      Api.Admin.Time,
      this._options,
      ADMTimeResult
    );
  }

  home(): Observable<ADMHomeResult> {
    return this.requestService.get(
      Api.Admin.Home,
      this._options,
      ADMHomeResult
    );
  }

  /** 제재명단(미국 SDN, EU, UN) 갱신 현황. */
  sanctionStatus(): Observable<ADMSanctionWatchResult> {
    return this.requestService.get(
      Api.Admin.SanctionStatus,
      this._options,
      ADMSanctionWatchResult
    );
  }

  /** 제재명단 수동 갱신 시작. list: US_SDN | EU | UN */
  sanctionRefresh(list: string): Observable<ADMSanctionWatchResult> {
    return this.requestService.post(
      Api.Admin.SanctionRefresh,
      this._options,
      { list: list },
      ADMSanctionWatchResult
    );
  }

  partnerdetail(partner_id: string): Observable<ADMPartnerDetailResult> {
    return this.requestService.get(
      Api.Admin.PartnerDetail(partner_id),
      this._options,
      ADMPartnerDetailResult
    );
  }

  /*FXRate*/

  fxpartners(): Observable<ADMPartnersResult> {
    return this.requestService.get(
      Api.Admin.FXPartner,
      this._options,
      ADMPartnersResult
    );
  }

  fxpayoutpartners(): Observable<ADMPartnersResult> {
    return this.requestService.get(
      Api.Admin.FXPayoutPartner,
      this._options,
      ADMPartnersResult
    );
  }

  fxcountrydetail(partner_id: string): Observable<ADMFxRateResult> {
    return this.requestService.get(
      Api.Admin.FXCountryRates(partner_id),
      this._options,
      ADMFxRateResult
    );
  }

  fxpartnerdetail(partner_id: string): Observable<ADMFxRateResult> {
    return this.requestService.get(
      Api.Admin.FXPartnerRates(partner_id),
      this._options,
      ADMFxRateResult
    );
  }

  fxratecountryupdate(
    partner_id: string,
    idx,
    rate: FxRate
  ): Observable<ADMFxRateResult> {
    return this.requestService.post(
      Api.Admin.FXCountryUpdate(partner_id, idx),
      this._options,
      rate,
      ADMFxRateResult
    );
  }

  fxratepartnerupdate(
    partner_id: string,
    idx,
    rate: FxRate
  ): Observable<ADMFxRateResult> {
    return this.requestService.post(
      Api.Admin.FXPartnerUpdate(partner_id, idx),
      this._options,
      rate,
      ADMFxRateResult
    );
  }

  fxnewcountry(rate: FxRate): Observable<ADMFxRateResult> {
    return this.requestService.post(
      Api.Admin.FxNewCountryRate(rate.partner_id),
      this._options,
      rate,
      ADMFxRateResult
    );
  }

  fxnewpartner(rate: FxRate): Observable<ADMFxRateResult> {
    return this.requestService.post(
      Api.Admin.FxNewPartnerRate(rate.partner_id),
      this._options,
      rate,
      ADMFxRateResult
    );
  }

  fxhistoryremitters(): Observable<ADMFxRateHistoryResult> {
    return this.requestService.get(
      Api.Admin.FxHistoryRemitters,
      this._options,
      ADMFxRateHistoryResult
    );
  }

  fxhistorycountries(partner_id: string): Observable<ADMFxRateHistoryResult> {
    return this.requestService.get(
      Api.Admin.FxHistoryCountries(partner_id),
      this._options,
      ADMFxRateHistoryResult
    );
  }

  fxhistorypartners(partner_id): Observable<ADMFxRateHistoryResult> {
    return this.requestService.get(
      Api.Admin.FxHistoryPartners(partner_id),
      this._options,
      ADMFxRateHistoryResult
    );
  }

  fxhistory(
    options: FxRateHistorySearch
  ): Observable<ADMFxRateHistoryListResult> {
    return this.requestService.post(
      Api.Admin.FxHistory,
      this._options,
      options,
      ADMFxRateHistoryListResult
    );
  }

  fxdelete(fxrate_idx): Observable<BaseResponse> {
    return this.requestService.get(
      Api.Admin.FxDeleteRate(fxrate_idx),
      this._options,
      BaseResponse
    );
  }

  fxpartnerrate(): Observable<ADMFxRateResult> {
    return this.requestService.get(
      Api.Admin.FXPartnerRate,
      this._options,
      ADMFxRateResult
    );
  }

  /*FXRate End*/

  /*ServiceCharge*/
  servicechargepartners(): Observable<ADMPartnersResult> {
    return this.requestService.get(
      Api.Admin.SVCChargePartner,
      this._options,
      ADMPartnersResult
    );
  }

  servicechargepayoutpartners(
    partner_id?: string
  ): Observable<ADMPartnersResult> {
    let url = Api.Admin.SVCChargePayoutPartner;
    if (partner_id) {
      url = url.concat("?except=" + partner_id);
    }
    return this.requestService.get(url, this._options, ADMPartnersResult);
  }

  servicechargecountrydetail(
    partner_id: string
  ): Observable<ADMServiceChargeResult> {
    return this.requestService.get(
      Api.Admin.SVCChargeCountryRates(partner_id),
      this._options,
      ADMServiceChargeResult
    );
  }

  servicechargepartnerdetail(
    partner_id: string
  ): Observable<ADMServiceChargeResult> {
    return this.requestService.get(
      Api.Admin.SVCChargePartnerRates(partner_id),
      this._options,
      ADMServiceChargeResult
    );
  }

  servicecharge3rdpartydetail(
    partner_id: string
  ): Observable<ADMServiceChargeResult> {
    return this.requestService.get(
      Api.Admin.SVCCharge3rdPartyRates(partner_id),
      this._options,
      ADMServiceChargeResult
    );
  }

  servicechargecountryupdate(
    partner_id: string,
    idx,
    charge: ServiceCharge
  ): Observable<ADMServiceChargeResult> {
    return this.requestService.post(
      Api.Admin.FXCountryUpdate(partner_id, idx),
      this._options,
      charge,
      ADMServiceChargeResult
    );
  }

  servicechargepartnerupdate(
    partner_id: string,
    idx,
    charge: ServiceCharge
  ): Observable<ADMServiceChargeResult> {
    return this.requestService.post(
      Api.Admin.FXPartnerUpdate(partner_id, idx),
      this._options,
      charge,
      ADMServiceChargeResult
    );
  }

  servicecharge3rdpartyupdate(
    partner_id: string,
    idx,
    charge: ServiceCharge
  ): Observable<ADMServiceChargeResult> {
    return this.requestService.post(
      Api.Admin.FXPartnerUpdate(partner_id, idx),
      this._options,
      charge,
      ADMServiceChargeResult
    );
  }

  servicechargenewcountry(
    charge: ServiceCharge
  ): Observable<ADMServiceChargeResult> {
    return this.requestService.post(
      Api.Admin.SVCChargeNewCountryCharge(charge.partner_id),
      this._options,
      charge,
      ADMServiceChargeResult
    );
  }

  servicechargenewpartner(
    charge: ServiceCharge
  ): Observable<ADMServiceChargeResult> {
    return this.requestService.post(
      Api.Admin.SVCChargeNewPartnerCharge(charge.partner_id),
      this._options,
      charge,
      ADMServiceChargeResult
    );
  }

  servicechargenew3rdparty(
    charge: ServiceCharge
  ): Observable<ADMServiceChargeResult> {
    return this.requestService.post(
      Api.Admin.SVCChargeNew3rdPartyCharge(charge.partner_id),
      this._options,
      charge,
      ADMServiceChargeResult
    );
  }

  servicechargeupdatecountry(
    charge: ServiceCharge
  ): Observable<ADMServiceChargeResult> {
    return this.requestService.post(
      Api.Admin.SVCChargeUpdateCountryCharge(charge.partner_id),
      this._options,
      charge,
      ADMServiceChargeResult
    );
  }

  servicechargeupdatepartner(
    charge: ServiceCharge
  ): Observable<ADMServiceChargeResult> {
    return this.requestService.post(
      Api.Admin.SVCChargeUpdatePartnerCharge(charge.partner_id),
      this._options,
      charge,
      ADMServiceChargeResult
    );
  }

  servicechargeupdate3rdparty(
    charge: ServiceCharge
  ): Observable<ADMServiceChargeResult> {
    return this.requestService.post(
      Api.Admin.SVCChargeUpdate3rdPartyCharge(charge.partner_id),
      this._options,
      charge,
      ADMServiceChargeResult
    );
  }

  servicechargedetailotherbank(
    partner_id: string,
    target_id: string
  ): Observable<ADMServiceChargeResult> {
    return this.requestService.get(
      Api.Admin.SVCChargeDetailOtherbank(partner_id, target_id),
      this._options,
      ADMServiceChargeResult
    );
  }

  servicechargedetailcash(
    partner_id: string,
    target_id: string
  ): Observable<ADMServiceChargeResult> {
    return this.requestService.get(
      Api.Admin.SVCChargeDetailCash(partner_id, target_id),
      this._options,
      ADMServiceChargeResult
    );
  }

  servicechargedetailewallet(
    partner_id: string,
    target_id: string
  ): Observable<ADMServiceChargeResult> {
    return this.requestService.get(
      Api.Admin.SVCChargeDetailEwallet(partner_id, target_id),
      this._options,
      ADMServiceChargeResult
    );
  }

  servicechargedetailRDA(
    partner_id: string,
    target_id: string
  ): Observable<ADMServiceChargeResult> {
    return this.requestService.get(
      Api.Admin.SVCChargeDetailRDA(partner_id, target_id),
      this._options,
      ADMServiceChargeResult
    );
  }

  servicechargedetailbank(
    partner_id: string,
    target_id: string
  ): Observable<ADMServiceChargeResult> {
    return this.requestService.get(
      Api.Admin.SVCChargeDetailBank(partner_id, target_id),
      this._options,
      ADMServiceChargeResult
    );
  }

  servicechargedetailall(
    partner_id: string,
    target_id: string
  ): Observable<ADMServiceChargeByTypeResult> {
    return this.requestService.get(
      Api.Admin.SVCChargeDetailAll(partner_id, target_id),
      this._options,
      ADMServiceChargeByTypeResult
    );
  }

  // servicechargedetailbytype(partner_id: string, target_id: string, type: string): Observable<ADMServiceChargeResult> {
  //   return this.requestService.get(Api.Admin.SVCChargeDetailByType(partner_id, target_id, type), this._options, ADMServiceChargeResult);
  // }

  servicechargedelete(idx: string): Observable<BaseResponse> {
    return this.requestService.get(
      Api.Admin.SVCChargeDelete(idx),
      this._options,
      BaseResponse
    );
  }

  servicechargedetail(idx: string): Observable<ADMServiceChargeDetailResult> {
    return this.requestService.get(
      Api.Admin.SVCChargeDetail(idx),
      this._options,
      ADMServiceChargeDetailResult
    );
  }

  /*ServiceCharge End*/

  reportpartners(): Observable<ADMReportPartnerResult> {
    return this.requestService.get(
      Api.Admin.ReportPartner,
      this._options,
      ADMReportPartnerResult
    );
  }

  reportInbpartners(): Observable<ADMReportPartnerResult> {
    return this.requestService.get(
      Api.Admin.ReportInbPartner,
      this._options,
      ADMReportPartnerResult
    );
  }

  reportdetail(
    partner_id: string,
    from: string,
    to: string
  ): Observable<ADMReportPartnerDetailResult> {
    return this.requestService.get(
      Api.Admin.ReportPartnerDetail(partner_id) + "?from=" + from + "&to=" + to,
      this._options,
      ADMReportPartnerResult
    );
  }

  inbreportdetail(
    partner_id: string,
    from: string,
    to: string
  ): Observable<ADMReportPartnerDetailResult> {
    return this.requestService.get(
      Api.Admin.InbReportPartnerDetail(partner_id) +
        "?from=" +
        from +
        "&to=" +
        to,
      this._options,
      ADMReportPartnerResult
    );
  }

  reportbokdaily(
    from: string,
    to: string
  ): Observable<ADMReportPartnerDetailResult> {
    return this.requestService.get(
      Api.Admin.ReportBOKDaily() + "?from=" + from + "&to=" + to,
      this._options,
      ADMReportPartnerResult
    );
  }

  reportbokedit(
    from: string,
    to: string
  ): Observable<ADMReportPartnerDetailResult> {
    return this.requestService.get(
      Api.Admin.ReportBOKEdit() + "?from=" + from + "&to=" + to,
      this._options,
      ADMReportPartnerResult
    );
  }

  inboundreportbokdaily(
    from: string,
    to: string
  ): Observable<ADMReportPartnerDetailResult> {
    return this.requestService.get(
      Api.Admin.InboundReportBOKDaily() + "?from=" + from + "&to=" + to,
      this._options,
      ADMReportPartnerResult
    );
  }
  customer(option: UserSearch): Observable<UserListResult> {
    return this.requestService.post(
      Api.Admin.CustomerList,
      this._options,
      option,
      UserListResult
    );
  }

  customerdetail(id: string): Observable<UserDetailResult> {
    return this.requestService.get(
      Api.Admin.CustomerList + "/" + id + "/detail",
      this._options,
      UserListResult
    );
  }

  customerregister(user: User): Observable<UserRegisterResult> {
    return this.requestService.post(
      Api.Admin.CustomerRegister,
      this._options,
      user,
      UserRegisterResult
    );
  }

  customerCheck(user: User): Observable<UserRegisterResult> {
    return this.requestService.post(
      Api.Admin.CustomerCheck,
      this._options,
      user,
      UserRegisterResult
    );
  }

  customermodify(user: User): Observable<UserModifyResult> {
    return this.requestService.post(
      Api.Admin.CustomerModify,
      this._options,
      user,
      UserModifyResult
    );
  }

  customerstatistics(
    id: string,
    year: number,
    type: string
  ): Observable<CustomerStatisticsResponse> {
    return this.requestService.get(
      Api.Admin.CustomerStatistics(id, year, type),
      this._options,
      CustomerStatisticsResponse
    );
  }

  customeraccountregistration(): Observable<BaseResponse> {
    return this.requestService.get(
      Api.Admin.CustomerAccountRegistration,
      this._options,
      BaseResponse
    );
  }

  customeraccountvalidation(
    account: AccountValidation
  ): Observable<BaseResponse> {
    return this.requestService.post(
      Api.Admin.CustomerAccountValidation,
      this._options,
      account,
      BaseResponse
    );
  }
  customerremittance(id: string): Observable<UserRemittanceResult> {
    return this.requestService.get(
      Api.Admin.CustomerRemittance(id),
      this._options,
      UserRemittanceResult
    );
  }
  customervalidatemobile(
    modify: UserValidateMobile
  ): Observable<UserValidateMobileResult> {
    return this.requestService.post(
      Api.Admin.CustomerValidateMobile,
      this._options,
      modify,
      UserValidateMobileResult
    );
  }

  customervalidatemobileresult(): Observable<UserValidateMobileResult> {
    return this.requestService.post(
      Api.Admin.CustomerValidateMobileResult,
      this._options,
      {},
      UserValidateMobileResult
    );
  }

  customerverifymobile(
    modify: UserVerifyMobile
  ): Observable<UserValidateMobileResult> {
    return this.requestService.post(
      Api.Admin.CustomerVerifyMobile,
      this._options,
      modify,
      UserValidateMobileResult
    );
  }

  customerblock(customer): Observable<UserValidateMobileResult> {
    return this.requestService.post(
      Api.Admin.CustomerBlock,
      this._options,
      customer,
      UserValidateMobileResult
    );
  }

  inbtransaction(
    option: TransactionSearch
  ): Observable<InbTransactionListResult> {
    return this.requestService.post(
      Api.Admin.InbTransaction,
      this._options,
      option,
      InbTransactionListResult
    );
  }

  subInftransaction(
    option: TransactionSubInfSearch
  ): Observable<TransactionSubInfListResult> {
    return this.requestService.post(
      Api.Admin.TransactionSubInf,
      this._options,
      option,
      TransactionSubInfListResult
    );
  }

  servicesubInftransactionNew(
    subInf: SubInfTransaction
  ): Observable<TransactionSubInfResult> {
    return this.requestService.post(
      Api.Admin.TransactionSubInfNew,
      this._options,
      subInf,
      TransactionSubInfResult
    );
  }

  servicesubInftransactionUpdate(
    subInf: SubInfTransaction
  ): Observable<TransactionSubInfResult> {
    return this.requestService.post(
      Api.Admin.TransactionSubInfUpdate,
      this._options,
      subInf,
      TransactionSubInfResult
    );
  }

  servicesubInftransactionDelete(
    value: string
  ): Observable<TransactionSubInfResult> {
    return this.requestService.get(
      Api.Admin.TransactionSubInfDelete(value),
      this._options,
      TransactionSubInfResult
    );
  }

  transactioncheckaml(id: string): Observable<TransactionCheckAMLResult> {
    return this.requestService.post(
      Api.Admin.AMLCheck,
      this._options,
      id,
      TransactionCheckAMLResult
    );
  }

  transactioncheckofac(
    detail: InbTransactionDetail
  ): Observable<TransactionCheckOFACResult> {
    return this.requestService.post(
      Api.Admin.AMLCheckOFAC,
      this._options,
      detail,
      TransactionCheckOFACResult
    );
  }

  transactioncheckremittance(
    InbData: ReqCheckRemittance
  ): Observable<TransactionCheckRemittanceResult> {
    return this.requestService.post(
      Api.Admin.AMLCheckRemittance,
      this._options,
      InbData,
      TransactionCheckRemittanceResult
    );
  }

  transactioncheckothersender(
    id: string
  ): Observable<TransactionCheckOtherSenderResult> {
    return this.requestService.post(
      Api.Admin.AMLCheckOtherSender,
      this._options,
      id,
      TransactionCheckOtherSenderResult
    );
  }

  transaction(option: TransactionSearch): Observable<TransactionListResult> {
    return this.requestService.post(
      Api.Admin.Transaction,
      this._options,
      option,
      TransactionListResult
    );
  }

  transactiondetail(id: string): Observable<TransactionDetailResult> {
    return this.requestService.get(
      Api.Admin.TransactionDetail + "/" + id,
      this._options,
      TransactionDetailResult
    );
  }

  inbtransactiondetail(id: string): Observable<InbTransactionDetailResult> {
    return this.requestService.get(
      Api.Admin.InbTransactionDetail + "/" + id,
      this._options,
      InbTransactionDetailResult
    );
  }

  inbtransactiondetailrefundisclaim(id: string): Observable<RefundClaimModel> {
    return this.requestService.get(
      Api.Admin.InbTransactionRefundIsClaim + "/" + id,
      this._options,
      RefundClaimModel
    );
  }

  inbtransactiondetailrefundgetinfo(id: string): Observable<RefundClaimModel> {
    return this.requestService.get(
      Api.Admin.InbTransactionRefundGetInfo + "/" + id,
      this._options,
      RefundClaimModel
    );
  }

  inbtransactiondetailrefundclaim(
    refundmodel: RefundModel
  ): Observable<RefundClaimModel> {
    return this.requestService.post(
      Api.Admin.InbTransactionRefundClaim,
      this._options,
      refundmodel,
      RefundClaimModel
    );
  }

  inbtransactiondetailrefundresult(id: string): Observable<RefundResult> {
    return this.requestService.get(
      Api.Admin.InbTransactionRefundResult + "/" + id,
      this._options,
      RefundResult
    );
  }

  transactioncancel(
    cancel: TransactionCancel
  ): Observable<TransactionCancelResult> {
    return this.requestService.post(
      Api.Admin.TransactionCancel,
      this._options,
      cancel,
      TransactionCancelResult
    );
  }

  transactionapprove(
    approve: TransactionApprove
  ): Observable<TransactionApproveResult> {
    return this.requestService.post(
      Api.Admin.TransactionApprove,
      this._options,
      approve,
      TransactionApproveResult
    );
  }

  inbtransactionapprove(
    approve: TransactionApprove
  ): Observable<TransactionApproveResult> {
    return this.requestService.post(
      Api.Admin.InbTransactionApprove,
      this._options,
      approve,
      TransactionApproveResult
    );
  }

  inbtransactionforceapprove(
    approve: TransactionApprove
  ): Observable<TransactionApproveResult> {
    return this.requestService.post(
      Api.Admin.InbTransactionForceApprove,
      this._options,
      approve,
      TransactionApproveResult
    );
  }

  inbtransactioncancel(
    cancel: TransactionCancel
  ): Observable<TransactionCancelResult> {
    return this.requestService.post(
      Api.Admin.InbTransactionCancel,
      this._options,
      cancel,
      TransactionCancelResult
    );
  }

  transactionreadytopay(
    readytopay: TransactionReadytoPay
  ): Observable<TransactionReadytoPayResult> {
    return this.requestService.post(
      Api.Admin.TransactionReadytoPay,
      this._options,
      readytopay,
      TransactionReadytoPayResult
    );
  }

  transactionpending(
    pending: TransactionPending
  ): Observable<TransactionPendingResult> {
    return this.requestService.post(
      Api.Admin.TransactionPending,
      this._options,
      pending,
      TransactionPendingResult
    );
  }

  transactionforcedapprove(
    approve: TransactionApprove
  ): Observable<TransactionApproveResult> {
    return this.requestService.post(
      Api.Admin.TransactionForcedApprove,
      this._options,
      approve,
      TransactionApproveResult
    );
  }

  transactionsender(option: UserSearch): Observable<CustomerListResult> {
    return this.requestService.post(
      Api.Admin.TransactionSender,
      this._options,
      option,
      CustomerListResult
    );
  }

  transactionreceiver(id: string): Observable<ReceiverListResult> {
    return this.requestService.get(
      Api.Admin.TransactionReceiver(id),
      this._options,
      ReceiverListResult
    );
  }

  accountvalidationInb(account: Account): Observable<BaseResponse> {
    return this.requestService.post(
      Api.Admin.AccountValidationInb,
      this._options,
      account,
      BaseResponse
    );
  }

  accountregistration(account: Account): Observable<BaseResponse> {
    return this.requestService.post(
      Api.Admin.AccountRegistration,
      this._options,
      account,
      BaseResponse
    );
  }

  transactioncountry(): Observable<PayoutCountryListResult> {
    return this.requestService.get(
      Api.Admin.TransactionCountry,
      this._options,
      PayoutCountryListResult
    );
  }

  transactionbankbranch(
    partner: string,
    payout_type: string
  ): Observable<PayoutBranchListResult> {
    return this.requestService.get(
      Api.Admin.TransactionPayoutBranch(partner, payout_type),
      this._options,
      PayoutBranchListResult
    );
  }

  transactionbank(partner: string): Observable<PayoutBankListResult> {
    return this.requestService.get(
      Api.Admin.TransactionPayoutBank(partner),
      this._options,
      PayoutBankListResult
    );
  }

  transactionbankbytype(
    partner: string,
    payout_type: string
  ): Observable<PayoutBankListResult> {
    return this.requestService.get(
      Api.Admin.TransactionPayoutBankByType(partner, payout_type),
      this._options,
      PayoutBankListResult
    );
  }

  transactioncashbranch(partner: string): Observable<PayoutBranchListResult> {
    return this.requestService.get(
      Api.Admin.TransactionPayoutCashBranch(partner),
      this._options,
      PayoutBranchListResult
    );
  }

  transactionbranchbytype(
    partner: string,
    type: string
  ): Observable<PayoutBranchListResult> {
    return this.requestService.get(
      Api.Admin.TransactionPayoutBranchByType(partner, type),
      this._options,
      PayoutBranchListResult
    );
  }

  transactionrate(payment: Payment): Observable<TransactionRateResult> {
    return this.requestService.post(
      Api.Admin.TransactionRate,
      this._options,
      payment,
      TransactionRateResult
    );
  }

  transactionsave(transaction: Transaction): Observable<TransactionSaveResult> {
    return this.requestService.post(
      Api.Admin.TransactionSave,
      this._options,
      transaction,
      TransactionSaveResult
    );
  }

  transactionvalid(transaction: Transaction): Observable<BaseResponse> {
    return this.requestService.post(
      Api.Admin.TransactionValid,
      this._options,
      transaction,
      BaseResponse
    );
  }

  transactionotp(transaction: Transaction): Observable<BaseResponse> {
    return this.requestService.post(
      Api.Admin.TransactionOTP,
      this._options,
      transaction,
      BaseResponse
    );
  }

  transactioncheckdeposit(
    detail: TransactionDetail
  ): Observable<DepositHistoryResult> {
    return this.requestService.post(
      Api.Admin.TransactionCheckDeposit,
      this._options,
      detail,
      DepositHistoryResult
    );
  }

  inbtransactioncheckdeposit(
    detail: InbTransactionDetail
  ): Observable<DepositHistoryResult> {
    return this.requestService.post(
      Api.Admin.TransactionCheckDeposit,
      this._options,
      detail,
      DepositHistoryResult
    );
  }

  checktransactiondetail(
    detail: InbTransactionDetail
  ): Observable<CustomerListResult> {
    // popup창에 띄울 KYC Information get
    return this.requestService.post(
      Api.Admin.TransactionCheckDetail,
      this._options,
      detail,
      CustomerListResult
    );
  }

  transactionrefreshdeposit(
    detail: TransactionDetail
  ): Observable<DepositHistoryResult> {
    return this.requestService.post(
      Api.Admin.TransactionRefreshDeposit,
      this._options,
      detail,
      DepositHistoryResult
    );
  }

  inbtransactionrefreshdeposit(
    detail: InbTransactionDetail
  ): Observable<DepositHistoryResult> {
    return this.requestService.post(
      Api.Admin.TransactionRefreshDeposit,
      this._options,
      detail,
      DepositHistoryResult
    );
  }

  transactionupdate(detail: TransactionDetail): Observable<BaseResponse> {
    return this.requestService.post(
      Api.Admin.TransactionUpdate,
      this._options,
      detail,
      BaseResponse
    );
  }

  transactionRefundedUpdate(
    detail: TransactionDetail
  ): Observable<BaseResponse> {
    return this.requestService.post(
      Api.Admin.transactionRefundedUpdate,
      this._options,
      detail,
      BaseResponse
    );
  }

  inbtransactioncomment(
    detail: InbTransactionDetail
  ): Observable<BaseResponse> {
    return this.requestService.post(
      Api.Admin.TransactionComment,
      this._options,
      detail,
      BaseResponse
    );
  }

  branchdetail(
    partner_id,
    branch_code: string
  ): Observable<BranchDetailResult> {
    return this.requestService.get(
      Api.Admin.BranchDetail(partner_id, branch_code),
      this._options,
      BranchDetailResult
    );
  }

  getbranchlist(partner_id: string): Observable<BranchListResult> {
    return this.requestService.get(
      Api.Admin.BranchList,
      this._options,
      BranchListResult
    );
  }

  getagentlist(partner_id: string): Observable<AgentListResult> {
    return this.requestService.get(
      Api.Admin.AgentList,
      this._options,
      AgentListResult
    );
  }

  branchnew(branch: PayoutBranch): Observable<BaseResponse> {
    return this.requestService.post(
      Api.Admin.BranchNew,
      this._options,
      branch,
      BaseResponse
    );
  }

  branchupdate(branch: PayoutBranch): Observable<BaseResponse> {
    return this.requestService.post(
      Api.Admin.BranchUpdate,
      this._options,
      branch,
      BaseResponse
    );
  }

  agentnew(agent: Agent): Observable<BaseResponse> {
    return this.requestService.post(
      Api.Admin.AgentNew,
      this._options,
      agent,
      BaseResponse
    );
  }

  agentupdate(agent: Agent): Observable<BaseResponse> {
    return this.requestService.post(
      Api.Admin.AgentUpdate,
      this._options,
      agent,
      BaseResponse
    );
  }

  agentdetail(id: string): Observable<AgentDetailResult> {
    return this.requestService.get(
      Api.Admin.AgentDetail(id),
      this._options,
      BaseResponse
    );
  }

  amlcheck(user: User): Observable<BaseResponse> {
    return this.requestService.post(
      Api.Admin.AMLCheck,
      this._options,
      user,
      BaseResponse
    );
  }

  fiureport(option: FIUReportSearch): Observable<BaseResponse> {
    return this.requestService.post(
      Api.Admin.FIUReport,
      this._options,
      option,
      BaseResponse
    );
  }

  fiureportdetail(item: FIUReportListItem): Observable<BaseResponse> {
    return this.requestService.post(
      Api.Admin.FIUReportDetail,
      this._options,
      item,
      BaseResponse
    );
  }

  fiublock(item: FIUReportDetail): Observable<BaseResponse> {
    return this.requestService.post(
      Api.Admin.FIUReportBlock,
      this._options,
      item,
      BaseResponse
    );
  }

  deposithistory(
    option: DepositHistoryListSearch
  ): Observable<BankDepositHistoryResult> {
    return this.requestService.post(
      Api.Admin.DepositHistyoryList,
      this._options,
      option,
      BankDepositHistoryResult
    );
  }

  depositinfo(history: DepositHistory): Observable<BaseResponse> {
    return this.requestService.post(
      Api.Admin.DepositInfo,
      this._options,
      history,
      BaseResponse
    );
  }

  sendSelectedTransactionsByEmail(
    tran_id: DepositHistoryByCheckedList
  ): Observable<BaseResponse> {
    return this.requestService.post(
      Api.Admin.SelectedDepositInfoByEmail,
      this._options,
      tran_id,
      BaseResponse
    );
  }

  getUserTransactionList(
    id: string,
    year: number,
    type: string
  ): Observable<UserTransactionListResult> {
    return this.requestService.get(
      Api.Admin.UserTransactionList + "/" + id + "/" + year + "/" + type,
      this._options,
      UserTransactionList
    );
  }

  updateKycStatus(id: string, status: string): Observable<BaseResponse> {
    return this.requestService.get(
      Api.Admin.UpdateKycStatus + "/" + id + "/" + status,
      this._options,
      BaseResponse
    );
  }

  resetFailedCount(id: string): Observable<BaseResponse> {
    return this.requestService.get(
      Api.Admin.ResetFailedCount + "/" + id,
      this._options,
      BaseResponse
    );
  }

  userNationalityList(): Observable<PayoutCountryListResult> {
    return this.requestService.get(
      Api.Admin.UserNationalityList,
      this._options,
      PayoutCountryListResult
    );
  }

  userOccupationList(): Observable<BaseResponse> {
    return this.requestService.get(
      Api.Admin.UserOccupationList,
      this._options,
      BaseResponse
    );
  }

  QSBranchList(): Observable<BaseResponse> {
    return this.requestService.get(
      Api.Admin.QSBranchList,
      this._options,
      BaseResponse
    );
  }

  agentInfoUpdate(agentType: AgentType): Observable<BaseResponse> {
    return this.requestService.post(
      Api.Admin.agentInfoUpdate,
      this._options,
      agentType,
      BaseResponse
    );
  }

  accountvalidation(account: ValidAccount): Observable<BaseResponse> {
    return this.requestService.post(
      Api.Admin.AccountValidation,
      this._options,
      account,
      BaseResponse
    );
  }

  accountvalidForceApprove(account: ValidAccount): Observable<BaseResponse> {
    return this.requestService.post(
      Api.Admin.AccountValidForceApprove,
      this._options,
      account,
      BaseResponse
    );
  }

  confirmAccount(confirm_account: Account): Observable<BaseResponse> {
    return this.requestService.post(
      Api.Admin.ConfirmAccount,
      this._options,
      confirm_account,
      BaseResponse
    );
  }

  /*notice*/
  notice(option: NoticeSearch): Observable<NoticeListResult> {
    return this.requestService.post(
      Api.Admin.NoticeList,
      this._options,
      option,
      NoticeListResult
    );
  }

  noticeDetail(idx: string): Observable<NoticeDetailResult> {
    return this.requestService.get(
      Api.Admin.Notice + "/" + idx + "/detail",
      this._options,
      NoticeListResult
    );
  }

  noticeInsert(notice: Notice): Observable<NoticeModifyResult> {
    return this.requestService.post(
      Api.Admin.NoticeInsert,
      this._options,
      notice,
      NoticeModifyResult
    );
  }

  noticeUpdate(notice: Notice): Observable<NoticeModifyResult> {
    return this.requestService.post(
      Api.Admin.NoticeUpdate,
      this._options,
      notice,
      NoticeModifyResult
    );
  }

  noticeDelete(idx: string): Observable<NoticeModifyResult> {
    return this.requestService.post(
      Api.Admin.NoticeDelete,
      this._options,
      idx,
      NoticeModifyResult
    );
  }

  noticeAlwaysShowOptionUpdate(
    list: Array<Notice>
  ): Observable<NoticeModifyResult> {
    return this.requestService.post(
      Api.Admin.NoticeAlwaysOptionUpdate,
      this._options,
      list,
      NoticeModifyResult
    );
  }

  push(option: PushSearch): Observable<PushListResult> {
    return this.requestService.post(
      Api.Admin.PushList,
      this._options,
      option,
      PushListResult
    );
  }

  pushDetail(idx: string): Observable<PushDetailResult> {
    return this.requestService.get(
      Api.Admin.Push + "/" + idx + "/detail",
      this._options,
      PushListResult
    );
  }

  pushInsert(push: Push): Observable<PushModifyResult> {
    return this.requestService.post(
      Api.Admin.PushInsert,
      this._options,
      push,
      PushModifyResult
    );
  }

  pushUpdate(push: Push): Observable<PushModifyResult> {
    return this.requestService.post(
      Api.Admin.PushUpdate,
      this._options,
      push,
      PushModifyResult
    );
  }

  pushDelete(idx: string): Observable<NoticeModifyResult> {
    return this.requestService.post(
      Api.Admin.PushDelete,
      this._options,
      idx,
      NoticeModifyResult
    );
  }

  server_version(): Observable<BaseResponse> {
    return this.requestService.get(
      Api.Admin.Version,
      this._options,
      BaseResponse
    );
  }

  customerfiledata(
    customer_idx: string,
    arg: number
  ): Observable<BaseResponse> {
    return this.requestService.get(
      Api.Admin.CustomerFileData + "/" + customer_idx + "/" + arg + "/data",
      this._options,
      BaseResponse
    );
  }

  inboundForcePaid(id: string): Observable<BaseResponse> {
    return this.requestService.get(
      Api.Admin.InboundForcePaid(id),
      this._options,
      BaseResponse
    );
  }

  /*mobile version*/
  mobileVersion(option: VersionSearch): Observable<VersionListResult> {
    return this.requestService.post(
      Api.Admin.MobileVersionList,
      this._options,
      option,
      VersionListResult
    );
  }

  mobileVersionDetail(
    os_info: string,
    version: string
  ): Observable<VersionDetailResult> {
    return this.requestService.get(
      Api.Admin.MobileVersion + "/" + os_info + "/" + version + "/detail",
      this._options,
      VersionListResult
    );
  }

  mobileVersionInsert(version: Version): Observable<VersionModifyResult> {
    return this.requestService.post(
      Api.Admin.MobileVersionInsert,
      this._options,
      version,
      VersionModifyResult
    );
  }

  mobileVersionUpdate(version: Version): Observable<VersionModifyResult> {
    return this.requestService.post(
      Api.Admin.MobileVersionUpdate,
      this._options,
      version,
      VersionModifyResult
    );
  }

  mobileVersionDelete(version: Version): Observable<VersionModifyResult> {
    return this.requestService.post(
      Api.Admin.MobileVersionDelete,
      this._options,
      version,
      VersionModifyResult
    );
  }

  getexpiredcustomerlist(search: ExpiredSearch): Observable<BaseResponse> {
    return this.requestService.post(
      Api.Admin.ExpiredCustomerList,
      this._options,
      search,
      BaseResponse
    );
  }

  getServiceListByPartner(partner_id: string): Observable<BaseResponse> {
    return this.requestService.get(
      Api.Admin.GetServiceListByPartner(partner_id),
      this._options,
      BaseResponse
    );
  }

  isExpiredWithdrawalAccount(customerId: string): Observable<BaseResponse> {
    return this.requestService.get(
      Api.Admin.isExpiredWithdrawalAccount(customerId),
      this._options,
      BaseResponse
    );
  }

  mypage(login: Admin): Observable<LoginResult> {
    return this.requestService.post(
      Api.Admin.MyPage,
      this._options,
      login,
      LoginResult
    );
  }

  mypageupdate(agent: Admin): Observable<BaseResponse> {
    return this.requestService.post(
      Api.Admin.MyPageUpdate,
      this._options,
      agent,
      BaseResponse
    );
  }

  passwordupdate(password: PasswordChange): Observable<BaseResponse> {
    return this.requestService.post(
      Api.Admin.PasswordUpdate,
      this._options,
      password,
      BaseResponse
    );
  }

  sendpdfemailtxnvoucher(data: EmailData): Observable<BaseResponse> {
    return this.requestService.post(
      Api.Admin.SendPdfEmail("voucher"),
      this._options,
      data,
      BaseResponse
    );
  }

  sendpdfemailcustomercertificate(data: EmailData): Observable<BaseResponse> {
    return this.requestService.post(
      Api.Admin.SendImgs,
      this._options,
      data,
      BaseResponse
    );
  }

  deletecustomeraccount(data: ReqDeleteAccount): Observable<BaseResponse> {
    return this.requestService.post(
      Api.Admin.DeleteAccount,
      this._options,
      data,
      BaseResponse
    );
  }

  customermodifyvalid(user: User): Observable<CustomerUpdateValidResult> {
    return this.requestService.post(
      Api.Admin.CustomerModifyValid,
      this._options,
      user,
      CustomerUpdateValidResult
    );
  }

  sendexceltxnmail(data: EmailData): Observable<BaseResponse> {
    return this.requestService.post(
      Api.Admin.SendExcelEmail,
      this._options,
      data,
      BaseResponse
    );
  }

  transactioncomment(detail: TransactionDetail): Observable<BaseResponse> {
    return this.requestService.post(
      Api.Admin.OutTransactionComment,
      this._options,
      detail,
      BaseResponse
    );
  }

  getpayoutbranches(
    partner: string,
    bank_code: string,
    payout_type: string
  ): Observable<PayoutBranchListResult> {
    const reqBody = new Object();
    reqBody["partner_id"] = partner;
    reqBody["bank_code"] = bank_code;
    reqBody["payout_type"] = payout_type;
    return this.requestService.post(
      Api.Admin.GetPayoutBranches,
      this._options,
      reqBody,
      PayoutBranchListResult
    );
  }

  sendauthcodetostaff(customer_idx: string): Observable<BaseResponse> {
    const reqBody = new Object();
    reqBody["customer_idx"] = customer_idx;
    return this.requestService.post(
      Api.Admin.SendAuthCodeToStaff,
      this._options,
      reqBody,
      BaseResponse
    );
  }

  getdepositpartners(): Observable<BaseResponse> {
    return this.requestService.get(
      Api.Admin.GetDepositPartners,
      this._options,
      BaseResponse
    );
  }

  allowoutboundtxn(customer_idx: string): Observable<BaseResponse> {
    const reqBody = new Object();
    reqBody["customer_idx"] = customer_idx;
    return this.requestService.post(
      Api.Admin.AllowOutboundTxn,
      this._options,
      reqBody,
      BaseResponse
    );
  }

  getcustomercountbykyc(): Observable<BaseResponse> {
    return this.requestService.get(
      Api.Admin.CustomerCountByKyc,
      this._options,
      BaseResponse
    );
  }

  insertmailinglist(data: MailSubscribe): Observable<BaseResponse> {
    return this.requestService.post(
      Api.Admin.InsertDailyMailingList,
      this._options,
      data,
      BaseResponse
    );
  }

  getdailymailinglists(): Observable<BaseResponse> {
    return this.requestService.get(
      Api.Admin.DailyMailingLists,
      this._options,
      BaseResponse
    );
  }

  updatedailymailinglists(data: UpdateMailingInfo): Observable<BaseResponse> {
    return this.requestService.post(
      Api.Admin.DailyMailingLists,
      this._options,
      data,
      BaseResponse
    );
  }

  deletedailymailinglistbymailaddress(data: string): Observable<BaseResponse> {
    const mailAddress = { mail_address: data };
    return this.requestService.post(
      Api.Admin.DeleteDailyMailingLists,
      this._options,
      mailAddress,
      BaseResponse
    );
  }

  payoutpartnergrouplist(): Observable<PartnerGroupResult> {
    return this.requestService.get(
      Api.Admin.PayoutPartnerGroupList,
      this._options,
      PartnerGroupResult
    );
  }

  requestReauthEmail(data: AuthInfo): Observable<BaseResponse> {
    return this.requestService.post(
      Api.Admin.RequestReauthEmail,
      this._options,
      data,
      BaseResponse
    );
  }

  queryStatusAuthEmail(customer_idx: string): Observable<BaseResponse> {
    return this.requestService.get(
      Api.Admin.QueryStatusAuthEmail(customer_idx),
      this._options,
      BaseResponse
    );
  }

  editBeneficiaryInfo(data: EditBeneficiaryParam): Observable<BaseResponse> {
    return this.requestService.post(
      Api.Admin.EditBeneficaryInfo,
      this._options,
      data,
      BaseResponse
    );
  }

  getCustomersAccountList(data: CustomerAcocuntList): Observable<BaseResponse> {
    return this.requestService.post(
      Api.Admin.CustomerAccouintList,
      this._options,
      data,
      BaseResponse
    );
  }

  approveRealNameAccount(data: { idx: string }): Observable<BaseResponse> {
    return this.requestService.post(
      Api.Admin.ApproveRealName,
      this._options,
      data,
      BaseResponse
    );
  }

  refreshKftcAgreementDate(
    data: RefreshKftcAgreementDate
  ): Observable<BaseResponse> {
    return this.requestService.post(
      Api.Admin.RefreshKftcDate,
      this._options,
      data,
      BaseResponse
    );
  }

  refreshKftcToken(data: RefreshKftcAgreementDate): Observable<BaseResponse> {
    return this.requestService.post(
      Api.Admin.RefreshKftcToken,
      this._options,
      data,
      BaseResponse
    );
  }

  sendThreeDigitCodeEmail(data: ThreeDigitCodeEmail): Observable<BaseResponse> {
    return this.requestService.post(
      Api.Admin.SendThreeDigitCodeEmail,
      this._options,
      data,
      BaseResponse
    );
  }

  getORISReports(data: {
    offset: number;
    pageSize: number;
  }): Observable<BaseResponse> {
    return this.requestService.get(
      Api.Admin.FindORISReports(data.offset, data.pageSize),
      this._options,
      BaseResponse
    );
  }

  searchORISReports(data: ORISReportSearch): Observable<BaseResponse> {
    return this.requestService.post(
      Api.Admin.FindORISReportsByOption,
      this._options,
      data,
      BaseResponse
    );
  }

  submitORISReport(data: SubmitORISReport): Observable<BaseResponse> {
    return this.requestService.post(
      Api.Admin.SubmitORISReport,
      this._options,
      data,
      BaseResponse
    );
  }

  getCustomerPassport(data: string): Observable<PassNoResult> {
    return this.requestService.get(
      Api.Admin.FindCustomerPassNo(data),
      this._options,
      BaseResponse
    );
  }

  getCustomerAlienCard(data: string): Observable<AlienRegCardResult> {
    return this.requestService.get(
      Api.Admin.FindCustomerAlineCard(data),
      this._options,
      BaseResponse
    );
  }

  resendORISReport(data: any) {
    return this.requestService.post(
      Api.Admin.ResendORISReport,
      this._options,
      data,
      BaseResponse
    );
  }

  searchBOKReports(data: any): Observable<BaseResponse> {
    return this.requestService.post(
      Api.Admin.FindBOKReportsByOption,
      this._options,
      data,
      BaseResponse
    );
  }

  deleteOrisReports(data: any) {
    return this.requestService.post(
      Api.Admin.DeleteORISReports,
      this._options,
      data,
      BaseResponse
    );
  }

  getOrisAccmulatedAmount(data: any): Observable<BaseResponse> {
    return this.requestService.post(
      Api.Admin.GetOrisAccmulatedAmount,
      this._options,
      data,
      BaseResponse
    );
  }

  getBOKReportDetail(data: any): Observable<BaseResponse> {
    return this.requestService.post(
      Api.Admin.GetBOKReportDetail,
      this._options,
      data,
      BaseResponse
    );
  }

  getOrphanedReports(dateFrom: string): Observable<BaseResponse> {
    return this.requestService.get(
      Api.Admin.GetOrphanedReports(dateFrom),
      this._options,
      BaseResponse
    );
  }

  cancelOrphanedReports(dateFrom: string): Observable<BaseResponse> {
    return this.requestService.post(
      Api.Admin.CancelOrphanedReports(dateFrom),
      this._options,
      {},
      BaseResponse
    );
  }

  getUnreportedTransactions(dateFrom: string): Observable<BaseResponse> {
    return this.requestService.get(
      Api.Admin.GetUnreportedTransactions(dateFrom),
      this._options,
      BaseResponse
    );
  }

  retryFailedORISReports(dateFrom: string): Observable<BaseResponse> {
    return this.requestService.post(
      Api.Admin.RetryFailedORISReports(dateFrom),
      this._options,
      {},
      BaseResponse
    );
  }

  getReconciliation(dateFrom: string, dateTo: string, includeOrisCheck: boolean): Observable<BaseResponse> {
    return this.requestService.get(
      Api.Admin.GetReconciliation(dateFrom, dateTo, includeOrisCheck),
      this._options,
      BaseResponse
    );
  }

  getReportMonitor(dateFrom: string, dateTo: string, includeOrisCheck: boolean): Observable<BaseResponse> {
    return this.requestService.get(
      Api.Admin.GetReportMonitor(dateFrom, dateTo, includeOrisCheck),
      this._options,
      BaseResponse
    );
  }

  backfillReport(bmi: string, transactionId: string): Observable<BaseResponse> {
    return this.requestService.post(
      Api.Admin.BackfillReport,
      this._options,
      { bmi: bmi, transactionId: transactionId },
      BaseResponse
    );
  }

  bokSenderOverrideList(): Observable<BaseResponse> {
    return this.requestService.get(
      Api.Admin.BokSenderOverrideList,
      this._options,
      BaseResponse
    );
  }

  bokSenderOverrideUpsert(data: any): Observable<BaseResponse> {
    return this.requestService.post(
      Api.Admin.BokSenderOverrideUpsert,
      this._options,
      data,
      BaseResponse
    );
  }

  bokSenderOverrideDelete(customerId: string): Observable<BaseResponse> {
    return this.requestService.get(
      Api.Admin.BokSenderOverrideDelete(customerId),
      this._options,
      BaseResponse
    );
  }

  bokSenderOverrideBulk(overrides: any[]): Observable<BaseResponse> {
    return this.requestService.post(
      Api.Admin.BokSenderOverrideBulk,
      this._options,
      overrides,
      BaseResponse
    );
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/service/admin/admin.service.ts